<template>
  <div class="container clearfix">
    <div class="shadow-wrapper padding-m mb-l">
      <h2 class="mb-m">相關條文</h2>
      <ServicePolicy v-model="hasAgree" />
    </div>
    <Button
      class="pull-right btn-primary btn-m"
      :disabled="!hasAgree"
      @click="nextStep"
      v-text="'下一步'"
    />
  </div>
</template>

<script>
  import { Button, Notice } from 'iview';
  import ServicePolicy from '@/components/auth/signup/ServicePolicy';

  export default {
    components: { Button, ServicePolicy },
    props: {
      isDevMode: {
        type: Boolean,
        default: () => process.env.NODE_ENV === 'development'
      }
    },
    data() {
      return {
        hasAgree: false
      };
    },
    methods: {
      nextStep() {
        if (!this.hasAgree) {
          return Notice.warning({
            title: '親愛的用戶您好',
            desc: '麻煩您先確認相關條文'
          });
        }
        return this.$emit('agree', true);
      }
    }
  };
</script>